import React, { Component, Fragment } from 'react';
import { change, formValues } from 'redux-form';
import * as actions from '../appFeedActions';
import { connect } from 'react-redux';
import {
  renderTextField,
  required,
  maxLength,
  urlValidation,
} from '../../../components/FormElements/ReduxForm';
import { AddCardWrapper } from './AppFeedElements';
import { Field } from 'redux-form';
import { ButtonRow, Button } from 'merchant-portal-components';
import { Select } from 'merchant-portal-components';
import ListSearchSelect from './ListSearchSelect';
// import { Select, InputLabel, FormControl } from "@material-ui/core";
import getOffers from '../../HOCs/Offers/getOffers';
import getCombos from '../../HOCs/Combos/getCombos';
import getCategories from '../../HOCs/Categories/getCategories';
import MediaModalContainer from '../../MediaModal/MediaModalContainer';
import { CustomizationContext } from '../../../utils/ClientCustomizationsProvider';
import SelectLocation from './SelectLocation';

import { makeStyles } from '@material-ui/core/styles';
import { th } from 'date-fns/locale';
const maxLength50 = maxLength(50);
const maxLength256 = maxLength(256);
const maxLength512 = maxLength(512);
const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export class CardFormElements extends Component {
  static contextType = CustomizationContext;
  state = {
    cardActionType: '',
    selectedItem: false,
    initialCardActionLoaded: false,
    mediaModalVisible: false,
    value: false,
  };
  componentDidMount() {
    const itemIndex = this.props.card.charAt(this.props.card.length - 2);
    let cardAction = null;

    if (this.props.formValues.items[itemIndex]) {
      const item = this.props.formValues.items[itemIndex];
      cardAction =
        item.feed_style_type === 'popup'
          ? item.button_action || item.card_action || null
          : item.card_action || item.button_action || null;
    }

    if (this.props.formValues.items[itemIndex]) {
      const item = this.props.formValues.items[itemIndex];
      cardAction =
        item.feed_style_type === 'popup'
          ? item.button_action || item.card_action || null
          : item.card_action || item.button_action || null;
    }

    if (cardAction) {
      const actionMap = {
        '://products': { key: 'allProducts', idField: 'id', type: 'product' },
        '://offers': { key: 'allOffers', idField: 'offer_id', type: 'offer' },
        '://combos': { key: 'allCombos', idField: 'id', type: 'combo' },
        '://category': {
          key: 'allCategories',
          idField: 'id',
          type: 'category',
        },
        '://businesses': {
          key: 'allBusinesses',
          idField: 'id',
          type: 'location',
        },
        '://business': {
          key: 'allBusinesses',
          idField: 'id',
          type: 'business',
        },
        'https://': { key: '', idField: 'id', type: 'webpage' },
      };

      // -----------------------------------------------------------------
      // 1. Find the *type* of the action (category, product, …)
      // -----------------------------------------------------------------
      const entry = Object.entries(actionMap).find(([path]) =>
        cardAction.includes(path)
      );

      if (!entry) {
        this.setState({ initialCardActionLoaded: true });
        return;
      }

      const [, { key, idField, type }] = entry;

      // -----------------------------------------------------------------
      // 2. CATEGORY is special – the URL can contain **two** IDs:
      //     parentId / childId   →  marybrowns://category/8532/13482
      // -----------------------------------------------------------------
      if (type === 'category') {
        const parts = cardAction.split('/').filter(Boolean); // ["marybrowns:", "category", "8532", "13482"]
        const categoryIdx = parts.indexOf('category');
        if (categoryIdx === -1) {
          this.setState({ initialCardActionLoaded: true });
          return;
        }

        const idsAfterCategory = parts.slice(categoryIdx + 1).map(Number); // [8532, 13482]
        const rawList = this.props[key] || [];

        let selectedItem = null;

        // ---- 2a. Only ONE id → top-level category -------------------
        if (idsAfterCategory.length === 1) {
          const [catId] = idsAfterCategory;
          selectedItem = rawList.find((c) => c[idField] == catId) || null;
        }

        // ---- 2b. TWO ids → sub-category -----------------------------
        else if (idsAfterCategory.length === 2) {
          const [parentId, childId] = idsAfterCategory;

          const parent = rawList.find((c) => c[idField] == parentId);
          if (parent && Array.isArray(parent.sub_categories)) {
            selectedItem =
              parent.sub_categories.find((sc) => sc[idField] == childId) ||
              null;
          }
        }

        this.setState({
          cardActionType: type,
          selectedItem,
          initialCardActionLoaded: true,
        });
        return;
      }

      // -----------------------------------------------------------------
      // 3. EVERY OTHER type – simple “last segment = id”
      // -----------------------------------------------------------------
      const selectedItemId = parseInt(cardAction.split('/').pop(), 10);
      const list = this.props[key] || [];

      const selectedItem =
        list.find((item) => item?.[idField] == selectedItemId) || null;

      this.setState({
        cardActionType: type,
        selectedItem,
        initialCardActionLoaded: true,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {}

  selectItem = (selectedItem) => {
    this.setState({ selectedItem });
    const { cardActionType } = this.state;
    const { change, card, appIdentifier, formValues } = this.props;

    const selectedName =
      selectedItem && cardActionType === 'offer'
        ? selectedItem?.template_name
        : selectedItem
        ? selectedItem.name
        : '';

    const selectedImageUrl =
      selectedItem && cardActionType === 'offer'
        ? selectedItem?.image_url
        : selectedItem
        ? selectedItem.image_url
        : '';

    const selectedId =
      selectedItem && cardActionType === 'offer'
        ? selectedItem?.offer_id
        : selectedItem
        ? selectedItem.id
        : '';
    if (selectedItem && cardActionType !== 'webpage') {
      const formattedAppIdentifier = appIdentifier.includes('_')
        ? appIdentifier.replaceAll('_', '')
        : appIdentifier;

      let path;
      switch (cardActionType) {
        case 'location':
          path = 'businesses';
          break;
        case 'category':
          path = selectedItem.parent_id
            ? `category/${selectedItem.parent_id}`
            : 'category';
          break;
        case 'business':
          path = 'businesses/menu';
          break;
        default:
          path = `${cardActionType}s`;
      }
      const deepLink = `${formattedAppIdentifier}://${path}/${selectedId}`;
      console.log('deepLink:', formattedAppIdentifier);
      console.log('formValues.feed_style_type:', formValues.feed_style_type);
      if (formValues.feed_style_type === 'popup') {
        change('feedRowForm', `${card}.button_action`, deepLink);
        change('feedRowForm', `${card}.card_action`, null);
      } else {
        change('feedRowForm', `${card}.card_action`, deepLink);
        change('feedRowForm', `${card}.button_action`, null);
        change('feedRowForm', `${card}.button_label`, null);
      }
    }
    change('feedRowForm', `${card}.title`, selectedName);
    change('feedRowForm', `${card}.subtitle`, cardActionType);
    change('feedRowForm', `${card}.background_image_url`, selectedImageUrl);
  };

  renderCardActionSelect = () => {
    const { cardActionType, selectedItem } = this.state;
    return cardActionType !== '' ? (
      <div style={{ marginTop: '32px', marginBottom: '28px' }}>
        <ListSearchSelect
          changed={(v) => this.setState({ value: v })}
          listKey={cardActionType}
          selectItem={this.selectItem}
          selectedItem={selectedItem}
          {...this.props}
        />
      </div>
    ) : null;
  };

  changeCardActionType = (value) => {
    this.setState({ cardActionType: value, selectedItem: false, value: true });
    const { change, card } = this.props;
    change('feedRowForm', `${card}.card_action`, '');
    change('feedRowForm', `${card}.button_action`, '');
    change('feedRowForm', `${card}.button_label`, '');
    change('feedRowForm', `${card}.title`, '');
    change('feedRowForm', `${card}.subtitle`, '');
    change('feedRowForm', `${card}.background_image_url`, '');
  };
  render() {
    const { cardActionType } = this.state;
    const { card, light } = this.props;
    const { isMultipleAppFeedItemClient } = this.context;
    const cardActionTypeOptions = isMultipleAppFeedItemClient
      ? [
          { value: '', label: 'Chose an action' },
          { value: 'webpage', label: 'Show a link' },
          { value: 'product', label: 'Show a product' },
          { value: 'offer', label: 'Show an offer' },
          { value: 'combo', label: 'Show a combo' },
          { value: 'category', label: 'Show a category' },
          { value: 'location', label: 'Show a location' },
          { value: 'business', label: 'Show a Business' },
          { value: 'category', label: 'Show a category' },
          { value: 'location', label: 'Show a location' },
        ]
      : [
          { value: '', label: 'Chose an action' },
          { value: 'webpage', label: 'Show a link' },
          { value: 'product', label: 'Show a product' },
          { value: 'offer', label: 'Show an offer' },
          { value: 'category', label: 'Show a category' },
          { value: 'combo', label: 'Show a combo' },
          { value: 'location', label: 'Show a location' },
        ];
    const isPopup = this.props.formValues.feed_style_type === 'popup';

    return (
      <Fragment>
        <div>
          <Select
            options={cardActionTypeOptions}
            value={cardActionTypeOptions.find(
              ({ value }) => value === cardActionType
            )}
            onChange={({ value }) => {
              this.changeCardActionType(value);
            }}
            className='react-select-container'
            classNamePrefix='react-select'
            label={isPopup ? 'Button Action' : 'Card Action'}
            topMod='-12px'
            zIndex={3}
            inLine
            whiteBackground
            light={light}
            name={`${card}.${isPopup ? 'button_action' : 'card_action'}`}
            validate={[required]}
          />

          {cardActionType === 'webpage' ? (
            <div style={{ marginTop: '18px' }}>
              {this.props.formValues.feed_style_type === 'popup' ? (
                <Field
                  name={`${card}.button_action`}
                  component={renderTextField}
                  type='url'
                  label='Card URL'
                  validate={[maxLength512]}
                  placeholder='https://google.ca'
                  light={light}
                />
              ) : (
                <Field
                  name={`${card}.card_action`}
                  component={renderTextField}
                  type='url'
                  label='Card URL'
                  validate={[maxLength512]}
                  placeholder='https://google.ca'
                  light={light}
                />
              )}
            </div>
          ) : cardActionType === 'location' ? (
            <SelectLocation
              selectItem={this.selectItem}
              selectedItem={this.state.selectedItem}
              isForAppFeed={true}
            />
          ) : (
            this.renderCardActionSelect()
          )}
        </div>
        {this.props.formValues.feed_style_type === 'popup' && (
          <Field
            label='Button Label *'
            name={`${card}.button_label`}
            component={renderTextField}
            validate={
              this.props.formValues.card_action !== ''
                ? [maxLength512, required]
                : [maxLength512]
            }
            type='text'
            light={light}
          />
        )}
        <Field
          label='Card Title'
          name={`${card}.title`}
          component={renderTextField}
          validate={maxLength50}
          type='text'
          light={light}
        />
        <Field
          label='Card Sub-Title'
          name={`${card}.subtitle`}
          component={renderTextField}
          validate={maxLength50}
          type='text'
          light={light}
        />

        <Field
          label='Card Description'
          name={`${card}.description`}
          component={renderTextField}
          validate={maxLength256}
          type='text'
          light={light}
          rows={3}
        />

        <Field
          label='Card Background Image URL'
          name={`${card}.background_image_url`}
          component={renderTextField}
          validate={[required, urlValidation]}
          type='text'
          light={light}
        />

        <Button
          type='button'
          primary
          onClick={() => this.setState({ mediaModalVisible: true })}
        >
          Gallery
        </Button>

        {this.state.mediaModalVisible && (
          <MediaModalContainer
            closeModal={() => this.setState({ mediaModalVisible: false })}
            selectProduct={(id, url) =>
              this.props.change(
                'feedRowForm',
                `${card}.background_image_url`,
                url
              )
            }
            name={`${card}.background_image_url`}
            buttonString='Option'
          />
        )}
      </Fragment>
    );
  }
}

const CardForm = (props) => {
  const { card, cancel, done, formValues, changed, touch } = props;
  // console.log('formValues:', formValues);

  function validation() {
    const item = formValues.items?.[0];
    if (formValues.feed_style_type === 'popup' && !item?.button_action === '') {
      if (!item?.button_label) {
        touch('feedRowForm', `${card}.button_label`);
        return false;
      }
      if (!item?.button_action) {
        touch('feedRowForm', `${card}.button_action`);
        return false;
      }
    }
    return true;
  }
  return (
    <AddCardWrapper>
      <CardFormElements
        card={card}
        light
        formValues={formValues}
        changed={changed}
        {...props}
      />
      <ButtonRow justifyContent='space-between'>
        <Button type='button' secondary small onClick={() => cancel()}>
          Cancel
        </Button>
        <Button
          type='button'
          small
          onClick={() => {
            validation() ? done() : null;
          }}
        >
          Done
        </Button>
      </ButtonRow>
    </AddCardWrapper>
  );
};

function mapStateToProps(state) {
  return {
    listByQuery: state.appFeed.listByQuery,
    requestingGetListByQuery: state.appFeed.requestingGetListByQuery,
    selectedListItemId: state.appFeed.selectedListItemId,
    feedRowFormIsVisible: state.appFeed.feedRowFormIsVisible,
    appIdentifier: state.accountReducer.appIdentifier,
    allProducts: state.productsReducer.allProducts,
  };
}

CardFormElements = getCombos(CardFormElements);
CardFormElements = getOffers(CardFormElements);
CardFormElements = getCategories(CardFormElements);

CardFormElements = connect(mapStateToProps, { change, ...actions })(
  CardFormElements
);

export default CardForm;
